module.exports = __webpack_public_path__ + "img/love-paws-homestay-grooming.dcdcce25.jpg";